/* src/app/components/payroll/timesheets/mass-adjustments/mass-batch-error-list/mass-batch-error-list.component.css */
.table-style {
  width: 100%;
}
.details-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
/*# sourceMappingURL=mass-batch-error-list.component-7JYGPKOM.css.map */
